export default "__VITE_ASSET__ebe19642__"